const brands = 
[
        {
            "id": 1,
            "alt": "legionextranjera",
            "texto":"",
            "tags":"",
            "titulo": "Legion Extranjera"
        },{
            "id": 2,
            "alt": "legionextranjera",
            "texto":"Orgullosos de desarrollar los productos más duraderos confeccionados en Argentina.",
            "tags":"Ecommerce-Brand site",
            "titulo": "Legion Extranjera"
        },{
            "id": 3,
            "alt": "legionextranjera_v2",
            "texto":"",
            "tags":"",
            "titulo": "Legion Extranjera_v2"
        },{
            "id": 4,
            "alt": "nickinicole",
            "texto":"",
            "tags":"",
            "titulo": "Nicki Nicole"
        },{
            "id": 5,
            "alt": "nickinicole",
            "texto":"Nicki Nicole, una figura clave en la música latina urbana.",
            "tags":"Ecommerce",
            "titulo": "Nicki Nicole"
        },{
            "id": 6,
            "alt": "lego",
            "texto":"",
            "tags":"",
            "titulo": "Lego"
        },{
            "id": 7,
            "alt": "lego",
            "texto":"Tienda oficial del célebre brick de construcción con vínculos a productos, juegos, videos, la tienda LEGO®.",
            "tags":"Ecommerce",
            "titulo": "Lego"
        },{
            "id": 8,
            "alt": "duki",
            "texto":"",
            "tags":"",
            "titulo": "Duki"
        },{
            "id": 9,
            "alt": "duki",
            "texto":"Duki, es un rapero y compositor argentino. Se le acredita el haber popularizado el género del trap a nivel mundial.",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Duki"
        },{
            "id": 10,
            "alt": "duki_v2",
            "texto":"",
            "tags":"",
            "titulo": "Duki_v2"
        },{
            "id": 11,
            "alt": "chimmychurry",
            "texto":"",
            "tags":"",
            "titulo": "Chimmy Churry"
        },{
            "id": 12,
            "alt": "chimmychurry",
            "texto":"Chimmy Churry Tienda Online — Sneakers y sandalias innovadoras para hombres y mujeres.",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Chimmy Churry"
        },{
            "id": 13,
            "alt": "regina",
            "texto":"Regina Tienda Online — Gotas autobronceantes iluminadoras REGINA® Serum para el rostro, cuello y escote. Bronceado perfecto y glow a medida. + Ac. Hialuronico y Aloe Vera.",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Regina"
        },{
            "id": 14,
            "alt": "regina",
            "texto":"",
            "tags":"",
            "titulo": "Regina"
        },{
            "id": 15,
            "alt": "hidrolit_v2",
            "texto":"",
            "tags":"",
            "titulo": "Hidrolit"
        },{
            "id": 16,
            "alt": "hidroli",
            "texto":"Tienda Hidrolit —  Empresa dedicada a fabricar purificadores de agua para hogares e industrias. La mejor y más compleja tecnología.",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Hidrolit"
        },{
            "id": 17,
            "alt": "hidrolit_v3",
            "texto":"",
            "tags":"",
            "titulo": "Hidrolit"
        },{
            "id": 18,
            "alt": "hudson",
            "texto":"",
            "tags":"",
            "titulo": "Hudson"
        },{
            "id": 19,
            "alt": "hudson",
            "texto":"Hudson Kitchen —  Ollas, Sartenes, Cacerolas — Artículos Hudson. Calidad premium para tu cocina. Ollas, Sartenes, Bowls, Cafeteras. Pavas.",
            "tags":"Ecommerce - Brand Site",
            "titulo": "Hudson"
        }
]
export default brands